import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { setDefaultOptions } from "date-fns";
import { it as dfnsIt, enUS as dfnsEnUS } from "date-fns/locale";
import it from "./translations/it.json";
import en from "./translations/en.json";

const supportedLangs = {
  it: { label: "Italiano", resources: it, dateFnsLocale: dfnsIt },
  en: { label: "English", resources: en, dateFnsLocale: dfnsEnUS },
} as const;

type SupportedLang = keyof typeof supportedLangs;

const langsArr = (Object.keys(supportedLangs) as SupportedLang[]).map((key) => ({
  key,
  label: supportedLangs[key].label,
}));

const resources = Object.fromEntries(
  Object.entries(supportedLangs).map(([key, v]) => [key, v.resources]),
) as Record<SupportedLang, (typeof supportedLangs)[SupportedLang]["resources"]>;

const isSupportedLang = (lang: string): lang is SupportedLang => lang in supportedLangs;

const normalizeLocale = (lang: string): SupportedLang => {
  const base = lang.split("-")[0].toLowerCase();
  return isSupportedLang(base) ? base : "it";
};

const getLocale = (): SupportedLang =>
  normalizeLocale(localStorage.getItem("catasto_currentLang") ?? navigator.language ?? "it");

const applyDateFnsLocale = () => {
  setDefaultOptions({ locale: supportedLangs[normalizeLocale(i18next.language)].dateFnsLocale });
};

void i18next.use(initReactI18next).init({ resources, fallbackLng: "it", lng: getLocale() });
applyDateFnsLocale();

i18next.on("languageChanged", applyDateFnsLocale);

export { langsArr };